import londonCarChargingImage from '../../../assets/images/london/car-charging.jpg';
import londonCentralImage from '../../../assets/images/london/central-london.jpg';
import londonSuburbsImage from '../../../assets/images/london/london-suburb-streets.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const london = {
    cityName: 'London',
    searchQuery: 'London',
    heroHeading: "London Calling! Find EV Chargers in London",
    heroSubheading: "Search for electric vehicle charging points across the capital. From Central London to Walthamstow, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try a London postcode, e.g. E17...",
    networkSection: {
        heading: "London's Charging Networks at Your Fingertips",
        paragraphs: [
            <>London has one of the most extensive EV charging networks in the UK, with thousands of public charge points spread across all 32 boroughs. By 2030 London is expected to need between <a href="https://lruc.content.tfl.gov.uk/electric-vehicle-infrastructure-strategy-2025.pdf#page=47" target="_blank" rel="noopener noreferrer">43,000 and 50,000 public chargers</a>.</>,
            "EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger wherever you are in the city.",
        ],
        image: londonCentralImage,
        imageAlt: "Electric vehicle charging at a public charge point in London",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up in the City or a slower overnight charger near your Hackney flat, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: londonCarChargingImage,
        imageAlt: "Central London streets for EV navigation",
    },
    navigateSection: {
        heading: "Navigate London's Streets with Confidence",
        paragraphs: [
            "Driving in London can be stressful enough without worrying about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey around the capital, whether you're heading through the Congestion Zone, cruising down the A40, or exploring the outer boroughs.",
        ],
        image: londonSuburbsImage,
        imageAlt: "EV charging in London",
    },
    seo: {
        title: "EV Charging Points in London | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across London. Search for public EV chargers in Central London, South London, North London, East London, and West London with EVBuddy.",
        keywords: "EV charging London, electric vehicle chargers London, EV charging points London, public EV chargers London, London electric car charging, charge my EV London, rapid chargers London",
        canonicalUrl: "https://evbuddy.io/london",
        ogImage: "https://evbuddy.io/static/media/central-london.jpg",
        ogDescription: "Find electric vehicle charging points across London. Search for public EV chargers with EVBuddy.",
    },
};

export default london;
